import axios from '../axios'
import {
    RSS_ARTICLES_REQUEST, RSS_ARTICLES_SUCCESS, RSS_ARTICLES_FAIL,
    RSS_FEEDS_LIST_REQUEST, RSS_FEEDS_LIST_SUCCESS, RSS_FEEDS_LIST_FAIL,
    RSS_FEED_CREATE_REQUEST, RSS_FEED_CREATE_SUCCESS, RSS_FEED_CREATE_FAIL,
    RSS_FEED_UPDATE_REQUEST, RSS_FEED_UPDATE_SUCCESS, RSS_FEED_UPDATE_FAIL,
    RSS_FEED_DELETE_REQUEST, RSS_FEED_DELETE_SUCCESS, RSS_FEED_DELETE_FAIL,
} from '../constants/rssConstants'

const authHeader = (userInfo) => ({
    headers: { Authorization: `Bearer ${userInfo.token}` }
})

const multipartHeader = (userInfo) => ({
    headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'multipart/form-data',
    }
})

export const listRssArticles = () => async (dispatch) => {
    try {
        dispatch({ type: RSS_ARTICLES_REQUEST })
        const { data } = await axios.get('/api/rss/')
        dispatch({ type: RSS_ARTICLES_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: RSS_ARTICLES_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}

// RSS Feed Management (Admin) - Requires Authorization
export const listRssFeeds = () => async (dispatch, getState) => {
    try {
        dispatch({ type: RSS_FEEDS_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get('/api/rss/feeds/', authHeader(userInfo))
        dispatch({ type: RSS_FEEDS_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: RSS_FEEDS_LIST_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}

export const createRssFeed = (name, url) => async (dispatch, getState) => {
    try {
        dispatch({ type: RSS_FEED_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post('/api/rss/feeds/', { name, url }, authHeader(userInfo))
        dispatch({ type: RSS_FEED_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: RSS_FEED_CREATE_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}

export const updateRssFeed = (id, is_active) => async (dispatch, getState) => {
    try {
        dispatch({ type: RSS_FEED_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/rss/feeds/${id}/`, { is_active }, authHeader(userInfo))
        dispatch({ type: RSS_FEED_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: RSS_FEED_UPDATE_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}

export const deleteRssFeed = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: RSS_FEED_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/rss/feeds/${id}/`, authHeader(userInfo))
        dispatch({ type: RSS_FEED_DELETE_SUCCESS })
    } catch (error) {
        dispatch({
            type: RSS_FEED_DELETE_FAIL,
            payload: error.response?.data?.detail || error.message,
        })
    }
}
